import { useBagContext } from '@app/contexts/Bag';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { MenuItemFavoritedOfBag, MenuItemWithDetailsOfBag } from '@app/types/menu-item';
import { useIsTabletOrMobileScreenSize } from '@app/utils/media-query';
import { deepCloneObject } from '@app/utils/object';
import React, { CSSProperties, useCallback } from 'react';
import Item from './Item';
import { default as classes, default as style } from './itensContent.module.css';

type Props = {
  onAddMoreItemsClick: () => void;
};

const MENU_VIEW_ONLY_TITLE_STYLE: CSSProperties = {
  backgroundColor: 'rgba(62, 192, 87, 0.1)',
  color: '#37b24d',
  padding: 10,
  borderRadius: 5,
};

export default function BagItems({ onAddMoreItemsClick }: Props) {
  const { items, deleteItemByIndex } = useBagContext();
  const {
    primaryColor,
    setSelectedMenuItemOfBagForEdit,
    isAInternalMenuOrOrderedOnRestaurant,
    isMenuOnlyView,
    cliqueiAcheiData,
  } = useRestaurantContext();
  const isTabletOrMobile = useIsTabletOrMobileScreenSize();

  const renderItem = useCallback((item: MenuItemWithDetailsOfBag | MenuItemFavoritedOfBag, index: number) => {
    return <Item key={item.bagItemId} item={item} onEditClick={handleEditClick} onDeleteClick={handleDeleteClick} />;

    function handleEditClick() {
      setSelectedMenuItemOfBagForEdit(deepCloneObject(item));
    }

    function handleDeleteClick() {
      deleteItemByIndex(index);
    }
  }, []);

  function getBagTitle() {
    if (isMenuOnlyView) {
      return `${cliqueiAcheiData.NomePuro} configurou este cardápio somente para visualização. Após escolher, chame o garçom e faça o seu pedido!`;
    }
    if (isAInternalMenuOrOrderedOnRestaurant) return `Itens Escolhidos`;
    return 'Itens na Sacola';
  }

  return (
    <div>
      <span className={style.title} style={isMenuOnlyView ? MENU_VIEW_ONLY_TITLE_STYLE : {}}>
        {getBagTitle()}
      </span>
      <div className={style.containerItens}>{items.map(renderItem)}</div>
      {isTabletOrMobile && (
        <div className={classes.addMoreItems} style={{ color: primaryColor }} onClick={onAddMoreItemsClick}>
          <p>{isAInternalMenuOrOrderedOnRestaurant ? 'Continuar escolhendo' : 'Adicionar mais itens ao pedido'}</p>
        </div>
      )}
    </div>
  );
}
